import React, { useEffect, useState, HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import INewsArticle from "apiConsumers/newsApiConsumer/models/INewsArticle";
import { newsApi } from "apiConsumers";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import SubArticleWithTitle from "components/news/articleOverviewWidgets/SubArticleOverviewWithTitle";
import Rotate from "components/rotate/Rotate";
import relatedNewsTitle from "assets/images/newsPage/title_relatedarticles.png";
import Spacer from "components/Spacer";

const useStyles = makeStyles((theme: Theme) => {
    const subArticleSpacing = theme.spacing(4);

    return createStyles({
        root: {},
        subArticleContainer: {
            display: "flex",
            [theme.breakpoints.down("sm")]: {
                flexDirection: "column",
            },
            marginBottom: -subArticleSpacing,
            marginRight: -subArticleSpacing,
        },
        subArticle: {
            flex: "1",
            marginRight: subArticleSpacing,
            marginBottom: subArticleSpacing,
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {
    articleUrl: string;
}

export default function RelatedNews(props: IProps) {
    const { articleUrl, className, ...rest } = props;

    const classes = useStyles();

    const [newsArticles, setNewsArticles] = useState<INewsArticle[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isError, setIsErrror] = useState<boolean>(false);

    const numberOfArticles = 3;

    useEffect(() => {
        setIsLoading(true);
        newsApi
            .getAllArticles({ pageOffset: 0, pageSize: numberOfArticles + 1 })
            .then((newsResponse) => {
                setNewsArticles(newsResponse.news.filter((article) => article.url !== articleUrl));
                setIsErrror(false);
            })
            .catch((err) => {
                setIsErrror(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [articleUrl]);

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {isError ? (
                <Typography variant="body2">
                    There has been an error fetching the news. Please try again.
                </Typography>
            ) : newsArticles?.length === 0 && !isLoading ? (
                <Typography>No recent news</Typography>
            ) : (
                <>
                    <Rotate amount={-1} style={{ display: "flex", justifyContent: "center" }}>
                        <img
                            src={relatedNewsTitle}
                            style={{ width: "100%", maxWidth: 550 }}
                            alt="Related News"
                        />
                    </Rotate>
                    <Spacer size={2} />
                    <div className={classes.subArticleContainer}>
                        {newsArticles.map((article, i) => {
                            if (i === numberOfArticles)
                                return <React.Fragment key={i}></React.Fragment>;

                            return (
                                <Rotate
                                    style={{ display: "flex", flex: "1" }}
                                    amount={i - 1}
                                    key={i}
                                >
                                    <SubArticleWithTitle
                                        article={article}
                                        className={classes.subArticle}
                                        isLoading={isLoading}
                                    />
                                </Rotate>
                            );
                        })}
                    </div>
                </>
            )}
        </div>
    );
}
